import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Shuffle } from "lucide-react";

export const DiscoverButton = ({ className = "", variant = "primary" }) => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const discover = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/videos/random");
      navigate(`/watch/${data.id}`);
    } catch {
      setBusy(false);
    }
  };

  const base = variant === "primary" ? "btn-primary" : "btn-ghost";
  return (
    <button data-testid="discover-btn" onClick={discover} disabled={busy}
      className={`${base} px-8 py-4 font-medium inline-flex items-center gap-2 disabled:opacity-60 ${className}`}>
      <Shuffle size={18} className={busy ? "animate-spin" : ""} />
      {busy ? "Finding something…" : "Discover Something New"}
    </button>
  );
};
